import { render, staticRenderFns } from "./Business-Glossary-Terms-Edit.vue?vue&type=template&id=0a8cd481&lang=pug"
import script from "./Business-Glossary-Terms-Edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./Business-Glossary-Terms-Edit.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports